import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import {
  Login,
  RegistrationForm,
  EmailSent,
  RegistrationCheckEmail,
} from '../components/registration';
import Error from './Error';
import { Dashboard, NewSubscription } from '../components/subscriber';
import {
  AuthLandingPage,
  AuthLoading,
  LogoutLoading
} from '../components/authenticate/';
import jwt from 'jwt-decode';

const Main = (props) => {
  const { logout } = props;
  const localAccountId = (localStorage.getItem('token') ? jwt(localStorage.getItem('token')).id : null);
  return (
    <main className="blank-footer">
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/logout" component={LogoutLoading} />
        <Route path="/register/:email" component={RegistrationForm} />
        <Route path="/subscribe/:parcelId" component={NewSubscription} />
        <Route exact path="/checkemail" component={RegistrationCheckEmail} />
        <Route path="/email" component={EmailSent} />
        <Route path="/error" component={Error} />
        <Route path="/dashboard/:accountId">
          <Dashboard logout={logout}/>
        </Route>
        <Route path="/auth/" component={AuthLandingPage} />
        <Route path="/loading/" component={AuthLoading} />
        <Route path="/">{localAccountId ? <Redirect to={`/dashboard/${localAccountId}`} /> : <Redirect to='/login' /> }</Route>
      </Switch>
    </main>
  );
};

export default Main;
